import Lottie from 'lottie-react';
import loadingAnimation from '@/assets/lottie/loading.json';
import { cn } from '@/lib/utils';

interface LoadingAnimationProps {
  className?: string;
}

export function LoadingAnimation({ className }: LoadingAnimationProps) {
  return (
    <div className={cn('w-20 h-20 lottie-icon-filter', className)}>
      <Lottie
        animationData={loadingAnimation}
        loop
        autoplay
        className="w-full h-full"
      />
    </div>
  );
}
